namespace Gamification.Gamification {
    export interface ProdottiParametriGlobaliForm {
        IdProdotto: Serenity.IntegerEditor;
        IdPunteggio: Serenity.StringEditor;
        PunteggioNome: Serenity.StringEditor;
        PunteggioValoreIniziale: Serenity.IntegerEditor;
        PunteggioNegativo: Serenity.IntegerEditor;
        IdCrediti: Serenity.StringEditor;
        CreditiNome: Serenity.IntegerEditor;
        CreditiValoreIniziale: Serenity.StringEditor;
    }

    export class ProdottiParametriGlobaliForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiParametriGlobali';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiParametriGlobaliForm.init)  {
                ProdottiParametriGlobaliForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(ProdottiParametriGlobaliForm, [
                    'IdProdotto', w0,
                    'IdPunteggio', w1,
                    'PunteggioNome', w1,
                    'PunteggioValoreIniziale', w0,
                    'PunteggioNegativo', w0,
                    'IdCrediti', w1,
                    'CreditiNome', w0,
                    'CreditiValoreIniziale', w1
                ]);
            }
        }
    }
}
